import React from "react";
import { IMAGES } from "@/constants/images";
import PageHero from "@/components/public/PageHero";
import CTASection from "@/components/public/CTASection";
import Reveal from "@/components/public/Reveal";
import { Search, Droplets, Filter, Ruler, Eye, Beaker, Coffee, PackageCheck } from "lucide-react";

const STEPS = [
  { icon: Search, title: "Green Bean Inspection", desc: "Visual inspection of green coffee for physical appearance and consistency." },
  { icon: Droplets, title: "Moisture Check", desc: "Moisture measured and recorded to agreed target ranges." },
  { icon: Filter, title: "Defect Sorting", desc: "Sorting to reduce defects according to buyer specification." },
  { icon: Ruler, title: "Screen Size", desc: "Screen size grading for consistent bean size." },
  { icon: Eye, title: "Physical Appearance", desc: "Assessment of color, uniformity and overall presentation." },
  { icon: Beaker, title: "Sample Evaluation", desc: "Representative samples prepared and evaluated." },
  { icon: Coffee, title: "Cupping Evaluation", desc: "Cupping notes recorded when evaluation is performed." },
  { icon: PackageCheck, title: "Packaging Inspection", desc: "Final check of packaging integrity before shipment." },
];

export default function Quality() {
  return (
    <div>
      <PageHero eyebrow="Quality Philosophy" title="Quality & Consistency" sub="Our quality-control philosophy centers on transparent specifications and careful preparation. We do not claim certifications we do not hold." image={IMAGES.drying} />
      <section className="mx-auto max-w-[1400px] px-4 py-16 sm:px-8 lg:px-12 lg:py-24">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STEPS.map((s, i) => (
            <Reveal key={s.title} delay={(i % 4) * 80}>
              <div className="h-full rounded-xl border border-forest/10 bg-white p-6 transition-all hover:-translate-y-1 hover:shadow-lg">
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-lg bg-beige text-forest"><s.icon className="h-5 w-5" /></div>
                <div className="font-mono text-[10px] uppercase tracking-wider text-amber-brand">0{i+1}</div>
                <h3 className="mt-1 font-display text-base font-bold text-forest-dark">{s.title}</h3>
                <p className="mt-2 font-body text-sm leading-relaxed text-espresso/65">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <Reveal>
          <div className="mt-14 rounded-2xl border border-forest/10 bg-beige p-8 text-center lg:p-12">
            <p className="mx-auto max-w-2xl font-body text-base leading-relaxed text-espresso/75">
              All technical specifications are entered and verified by our team for each coffee lot. We do not claim organic, fair trade, Rainforest Alliance, ISO or HACCP certification unless verified and provided.
            </p>
          </div>
        </Reveal>
      </section>
      <CTASection />
    </div>
  );
}
